import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../reducers';

export const currentDivisionSliceSelector = (state: StorageState) => state.app.currentDivision;

export const currentDivisionDataSelector = createSelector(
    currentDivisionSliceSelector,
    division => division.data
);
